var module = angular.module('octopusApp.environments');

module.controller('MachineDeploymentsController', function ($scope, machineState, $location, busy, octopusRepository, pollLoop) {
  $scope.machineId = machineState.machineId;
  $scope.isLoading = busy.create();
  $scope.isSaving = busy.create();
  $scope.skip = 0;

  $scope.loadPage = loadPage;

  function loadPage(skip) {
    $scope.skip = skip;
    refresh();
  }


  function refresh() {
    return $scope.isLoading.promise(machineState.load().then(function (machine) {
      $scope.machine = machine;

      return octopusRepository.Machines.getTasks(machine, { skip: $scope.skip }).then(function (tasks) {
        $scope.tasks = tasks;
      });
    }));
  }

  pollLoop.create($scope, function () {
    return refresh();
  }).startImmediately();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machines/machine_deployments.js
// module id = 6749819832087667
// module chunks = 1